/**
 * Whether the workspace-scoped "Save Selected" write is allowed (FS-520).
 *
 * In Data-Catalog mode the page is opened with selected documents and NO board,
 * so `context_id` (the would-be workspace target) is whatever board/timeseries/
 * chat the user last visited this session — a *stale, unrelated* workspace.
 * The tenant run already auto-persists matches (workspace_id=NULL), so a
 * workspace-scoped save here is both redundant and, against a stale id, writes
 * spurious match rows to the wrong board. So: never allow the workspace save in
 * Data-Catalog mode. Accept/reject in Data-Catalog mode is persisted instead as
 * tenant-scoped feedback keyed on the match row id (submitTenantMatchFeedback).
 */
export function isWorkspaceSaveAllowed(
  isDataCatalogMode: boolean,
  workspaceId: string | null | undefined,
): workspaceId is string {
  return !isDataCatalogMode && !!workspaceId
}
